import { IApiClient } from "@common/network/interfaces";
import { ApiClient } from "@network/client";
import { getConfig } from "@config/index";
import {
  createFolder, deleteFolder, fetchFolder, getFolderById, updateFolder, bulkUpdateFormFolderPath,
} from "../apis/urls";
import { IBulkUpdateFormFolderPathActionPayload, IFetchFoldersByPathActionPayload, IFoldersDataServer } from "@common/redux/folders/interface";

const ENDPOINTS = {
  fetchFolders: () => fetchFolder,
  createFolder: () => createFolder,
  updateFolder: () => updateFolder,
  deleteFolder: () => deleteFolder,
  getFolderById: () => getFolderById,
  bulkUpdateFormFolderPath: () => bulkUpdateFormFolderPath,

};
class FoldersRepository {
  private apiClient: IApiClient;
  constructor(apiClient: IApiClient) {
    this.apiClient = apiClient;
  }

  public fetchFolders = async (data: IFetchFoldersByPathActionPayload) => {
    const folderPath = data?.folderPath;
    const result = await this.apiClient.get(ENDPOINTS.fetchFolders() + `?folderPath=${folderPath}`,
      {},
      {});
    return result.data;
  };



  public createFolders = async (data: IFoldersDataServer) => {
    const payload = data;
    const result = await this.apiClient.post(
      ENDPOINTS.createFolder(),
      payload,
      {},
      {});
    return result.data;
  };




  public updateFolders = async (data: IFoldersDataServer) => {
    const payload = data;
    const result = await this.apiClient.put(
      ENDPOINTS.updateFolder(),
      payload,
      {},
      {});
    return result.data;
  };



  public deleteFolders = async (folderId: string) => {
    const result = await this.apiClient.delete(
      `${ENDPOINTS.deleteFolder()}/${folderId}`,
      {},
      {});
    return result.data;
  };


  public fetchFolderById = async (folderId: string) => {
    const result = await this.apiClient.get(
      ENDPOINTS.fetchFolders() + folderId,
      {},
      {});
    return result.data;
  };



  public bulkUpdateFormFolderPath = async (data: IBulkUpdateFormFolderPathActionPayload) => {
    const params = { ids: data?.folderIds }; //data?.folderIds.join("%2C");
    const payload = {
      folderPath: data?.folderPath,
    }
    const result = await this.apiClient.put(
      ENDPOINTS.bulkUpdateFormFolderPath(),
      payload,
      params,
      {});
    return result.data;
  };


}

const foldersRepository = new FoldersRepository(ApiClient);

export { foldersRepository as FoldersRepository };
